import request from '@/utils/request'

const getAddresses = () => {
  return request({
    url: '/shop/addresses',
    method: 'get'
  })
}

const addAddress = (data) => {
  return request({
    url: '/shop/addresses',
    data: data,
    method: 'post'
  })
}

const getAddressesDetail = (id) => {
  return request({
    url: `/shop/addresses/${id}`,
    method: 'get'
  })
}

const modifyAddress = (id, data) => {
  return request({
    url: `/shop/addresses/${id}`,
    data: data,
    method: 'put'
  })
}

const deleteAddress = (id) => {
  return request({
    url: `/shop/addresses/${id}`,
    method: 'delete'
  })
}

const modifyAddressDef = (id) => {
  return request({
    url: `/shop/addresses/${id}/def`,
    method: 'put'
  })
}

export {
  getAddresses, // 批量查询收货地址信息
  addAddress, // 添加收货地址
  getAddressesDetail, // 获取收货地址详情
  modifyAddress, // 修改收货地址信息
  deleteAddress, // 删除收货地址
  modifyAddressDef // 设置为默认地址
}
